module.exports = __webpack_public_path__ + "img/logo.c77c66d1.png";